import {clsx} from 'clsx'
import type {ReactNode} from 'react'
import styles from './Action.module.css'

export function SidebarAction({
  children,
  hover = false,
  muted = false,
}: {
  children: ReactNode
  hover?: boolean
  muted?: boolean
}) {
  return (
    <span
      data-sidebar-action
      data-component="Sidebar.Action"
      className={clsx(styles.Action, hover && styles.hover, muted && styles.muted)}
    >
      <span data-sidebar-collapse-content className={styles.Content}>
        {children}
      </span>
    </span>
  )
}
